import { render, staticRenderFns } from "./PictionaryPresenterComponent.vue?vue&type=template&id=366f1097&scoped=true&"
import script from "./PictionaryPresenterComponent.vue?vue&type=script&lang=js&"
export * from "./PictionaryPresenterComponent.vue?vue&type=script&lang=js&"
import style0 from "./PictionaryPresenterComponent.vue?vue&type=style&index=0&id=366f1097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f1097",
  null
  
)

export default component.exports